<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Karir',

    metaInfo: { title: 'Karir' },

    extends: View,

    mixins: [
      LoadSections([
        'careers',
        'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'career',
      },
    },
  }
</script>
